import { Component, TemplateRef, viewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mib-step-footer',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './step-footer.component.html',
})
export class StepFooterComponent {
  readonly content = viewChild<TemplateRef<any>>('template');
}
